import {PatternLine} from "./PatternLine";
import * as PropTypes from "prop-types";

PatternSegment.propTypes = {
    increase: PropTypes.number,
    height: PropTypes.number,
    size: PropTypes.number,
    shift: PropTypes.number,
    left: PropTypes.bool,
    index: PropTypes.number,
    zindex: PropTypes.number,
    tiles: PropTypes.array,
    onTileClick: PropTypes.func,
    colors: PropTypes.array,
    editable: PropTypes.bool,
}

export function PatternSegment(props) {
    let k = 0;
    let lines = [];
    for (let i = 0; i < props.increase; i++) {
        let shift = 0;
        if (props.left) {
            shift = (props.increase - i) / 2 + props.height / 2 - 0.5;
        } else {
            shift = props.increase / 2 - i / 2;
        }
        lines.push(
            <PatternLine
                key={k++}
                pattern_lenght={1 + i}
                size={props.size}
                shift={shift}
                tiles={props.tiles[k]}
                onTileClick={(k, t) => props.onTileClick(k, i, t)}
                colors={props.colors}
                editable={props.editable}
            />
        );
    }
    // lines.push(<hr key={k++} style={{width: 'calc(100% + 40px)', margin: 0, borderBottom: 0, marginLeft: -30}}/>)
    for (let i = 0; i < props.height; i++) {
        let shift = 0;
        if (props.left) {
            shift = props.height / 2 - i / 2 - 0.5;
        } else {
            shift = i / 2
        }
        lines.push(
            <PatternLine
                key={k++}
                pattern_lenght={props.increase + 1}
                size={props.size}
                shift={shift}
                tiles={props.tiles[k]}
                onTileClick={(k, t) => props.onTileClick(k, i + props.increase, t)}
                colors={props.colors}
                editable={props.editable}
            />
        );
    }
    // lines.push(<hr key={k++} style={{width: 'calc(100% + 40px)', margin: 0, borderBottom: 0, position: 'relative', top: 1, marginLeft: -30}}/>)
    for (let i = 0; i < props.increase; i++) {
        let shift = 0;
        if (props.left) {
            shift = i / 2 + 0.5;
        } else {
            shift = props.height / 2 + i / 2;
        }
        lines.push(
            <PatternLine
                key={k++}
                pattern_lenght={props.increase - i}
                size={props.size}
                shift={shift}
                tiles={props.tiles[k]}
                onTileClick={(k, t) => props.onTileClick(k, i + props.height + props.increase, t)}
                colors={props.colors}
                editable={props.editable}
            />
        );
    }
    let patterShift = props.shift * props.size;
    let className = "pattern-segment segment-" + (props.index % 2 ? "even" : "odd");
    return (
        <div className={className} style={{marginLeft: patterShift, zIndex: props.zindex}}>
            {lines}
        </div>
    );
}